exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "text{font:12px sans-serif}#barChart{display:block;margin:0px;padding:0px;height:100%;width:100%}\n", ""]);

